var _defs, _path, _path2, _path3, _path4, _line, _path5, _polyline, _ellipse, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polyline2, _polyline3, _path13, _path14, _path15, _path16, _path17, _path18, _line2, _line3, _line4, _line5, _path19, _path20, _line6, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path21, _ellipse6, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _line7, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsweria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.17 224.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d88b0f;}.cls-2{fill:#fff;}.cls-10,.cls-2,.cls-3{stroke:#232323;}.cls-10,.cls-2,.cls-3,.cls-4,.cls-9{stroke-linecap:round;}.cls-10,.cls-2,.cls-3,.cls-4{stroke-linejoin:round;stroke-width:5px;}.cls-3{fill:#ffc13a;}.cls-10,.cls-4,.cls-9{fill:none;}.cls-4{stroke:#fff;}.cls-5{fill:#ffa401;}.cls-6{fill:#e56467;}.cls-7{fill:#a585db;}.cls-8{fill:#ffc25f;}.cls-9{stroke:#f4e977;stroke-miterlimit:10;stroke-width:8px;}.cls-11{fill:#232323;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "capy_happy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.87,215.82",
    transform: "translate(-33.88 -43.6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242,151.15l25.1-2.25s16.51,23.49,47.4,15.32,36-42.89,27.32-60S306.2,79.63,286.88,85.59c-22.19,6.84-34.67,33.59-27.83,48.51Z",
    transform: "translate(-33.88 -43.6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.24,117.93s-6.81-5.62-14.55-1.2-8.77,19,21.95,24.34c0,0,22.13-22.55,11.75-31.83S300.24,117.93,300.24,117.93Z",
    transform: "translate(-33.88 -43.6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.66,112.22s3.58,1.37,2.3,7.24",
    transform: "translate(-33.88 -43.6)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 276.82,
    y1: 84.88,
    x2: 277.33,
    y2: 84.11
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.34,100.66l-9.1-12L85,70.35,82.63,54.82l-11.07-8L58.45,50.1,53.68,67.72l4.26,18.55,3.71,9.13,7.44,6.78L74.71,106l6.46,3.15,4.87,1.9L85,115,52.67,160.64l-9.8,17-5.44,15.48,2.92,5.53,6.58-.5,2,2.08L42.49,220.5l2.81,10.08,4,3.53,8.37,6,7,4,5.68.85,4.11,6.68,7.43,8.45L89.17,264l7.4,2,9.71-.89s10.5-2.38,10.69-2.46,8.21-4.67,8.21-4.67l2.7-4,9.25-1.8,10.09,1,9,1.53,8.1,6.15,21.22,2.75,11.72-5.9,6-4.09,3.63-6.25,4.12-3.7,11.69-3.48L236,229.39l3.1-10-2.38-8.68-3.23-8.51,1.19-4,7,1.21,2.21-4.19-6.48-17.69-19.5-31.69L199,119.67l-5.28-5.26,2.22-3.53,11.26-4.5,10.64-8.16,6.15-12,2.66-12.77-.89-13.07-4.6-10.8-8-3.71-11.75,3.19-5.48,8.3-1.51,13.82-1.27,13-6,13.61-4,2.88-8.79-.34L161,97.41l-17.56-1.72L120.84,97l-18.3,5.14-5.2-1.44",
    transform: "translate(-33.88 -43.6)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "94.97 153.4 95.09 159.5 99.5 168.37 102.78 171.57 107.89 172.45 113.59 170.16 116.16 166.24 117.67 158.58 119.52 155.61 116.16 152.11 108.65 147.18 103.88 147.18 101.5 150.84 94.97 153.4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 105.93,
    cy: 117.94,
    rx: 32.94,
    ry: 15.19
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M104.33,101.2s64.21,5.69,69.19,2.24-13.59-5.28-13.59-5.28l-40.11-.45-16.33,2.92",
    transform: "translate(-33.88 -43.6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M200.07,51.12s16-6.26,17.1,8.93a122.31,122.31,0,0,0,5.18,27.07l1.72-14.43.91-8.8-1.95-8-5.33-7.76-9.59-1.77Z",
    transform: "translate(-33.88 -43.6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58,52.05s16.68,0,17.19,24S92.05,97,92.05,97l-4.52-7.89-1.71-9-1-12-1.11-7.64-1.3-7-4.28-4-9.17-3.44L61.78,48.5",
    transform: "translate(-33.88 -43.6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M221.7,152.42s13.32,44.16,17.5,45.69,2.73-4.25,2.73-4.25L239,184",
    transform: "translate(-33.88 -43.6)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.86,218s22.85,12.91,23.29,22.61-3.76-17.1-3.76-17.1L196.8,218l-4.14-.88h-7.53",
    transform: "translate(-33.88 -43.6)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M103.37,223.46s9.25.7,10.21,7.85,16.53,8,17.23,13,1.25-6.68,1.25-6.68l-4.31-5.39-4.66-3.06-5.38,3-2.47-6.38-1.66-3.9Z",
    transform: "translate(-33.88 -43.6)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.79,232.52s9.45,29.33,31.53,30.94-14.93,1.36-14.93,1.36l-11.54-8.63s-4.83-5.7-5.06-6.07-5.1-6.24-5.1-6.24l-11.07-4.24L45,230.79",
    transform: "translate(-33.88 -43.6)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "111.68 199.08 96.27 205.39 96.27 209.22 112.9 209.13 114.69 205.54 111.04 199.08"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "173.84 189.99 192.23 190.92 184.54 199.52 173.3 200.2 174.36 191.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.58,238.69s22.11,22.61,32,23.6-12.8-1.11-12.8-1.11l-6.58-3.94-7.69-5-5-4.5-3.19-7.31",
    transform: "translate(-33.88 -43.6)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.52,200.22s5.48,18.26,11.68,18.64,5.44-2.61,5.44-2.61l-8.57-6.71-3-6.7-1.85-3.63-5.3.31",
    transform: "translate(-33.88 -43.6)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.05,91.05s8.55,12.47,1.85,12.6-10.41-4.92-10.21-5,3.76-2.16,3.76-2.16l2.94-2.89,1.21-3.7",
    transform: "translate(-33.88 -43.6)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.68,67.72s16.05,31.14,25,33.57,6,9.23,6,9.23l-11.34-4-7.68-4.9-6.25-6.89L54.18,82l-.5-9.29Z",
    transform: "translate(-33.88 -43.6)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.7,131.74s-24.78,55.31-23.29,64-2.63,1.91-2.63,1.91l-4.53,1.51-5-5.25L37.52,187l6-13.1,14.73-23.74",
    transform: "translate(-33.88 -43.6)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.78,197.67s-.12,28,6.86,30,18.19,2.17,18.19,2.17l-7.29,8.81s-8.68-4-9.54-4.17-9.7-3.73-9.7-3.73L42,226.36l-.72-3.25",
    transform: "translate(-33.88 -43.6)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 31.31,
    y1: 159.06,
    x2: 26.46,
    y2: 168.89
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 42.53,
    y1: 161.06,
    x2: 37.68,
    y2: 170.89
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 165.25,
    y1: 157.73,
    x2: 172.4,
    y2: 172.22
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 177.39,
    y1: 154.97,
    x2: 184.54,
    y2: 169.46
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M99.43,228.05s.89-9.44-10.6-10.08S68.54,235.2,72,247.46s17.49,17.87,25.28,18.13,27.19-2.56,34-16.86-9.83-24.63-14.17-16.59c0,0,0-11.11-6.9-11.87S99.43,228.05,99.43,228.05Z",
    transform: "translate(-33.88 -43.6)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M179,225.92s-.89-9.45,10.6-10.09,20.29,17.24,16.85,29.49-17.49,17.87-25.28,18.13-27.19-2.55-34-16.85S157,222,161.33,230c0,0,0-11.1,6.9-11.87S179,225.92,179,225.92Z",
    transform: "translate(-33.88 -43.6)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 96.27,
    y1: 208.65,
    x2: 115.55,
    y2: 208.06
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 97.02,
    cy: 151.15,
    rx: 27.18,
    ry: 22.98,
    transform: "translate(-108.66 159.96) rotate(-74.27)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 181.02,
    cy: 150.15,
    rx: 22.98,
    ry: 27.18,
    transform: "matrix(0.96, -0.27, 0.27, 0.96, -67.81, 11.11)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 74.02,
    cy: 104.2,
    rx: 10.89,
    ry: 18.13
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 136.25,
    cy: 104.2,
    rx: 10.89,
    ry: 18.13
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M160.11,171.05c0,5.19-9.25,9.39-20.66,9.39a38.24,38.24,0,0,1-13.26-2.19c-4.52-1.72-7.4-4.31-7.4-7.2,0-5.18,9.25-9.38,20.66-9.38S160.11,165.87,160.11,171.05Z",
    transform: "translate(-33.88 -43.6)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 105.57,
    cy: 136.07,
    rx: 10.6,
    ry: 7.53
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M109.09,189.5s4.43.43,8.94-4.85",
    transform: "translate(-33.88 -43.6)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M161.26,184.65s6.47,4.17,10.3,3.4",
    transform: "translate(-33.88 -43.6)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M114.6,187.71s2.87,11.24,8.11,11.17,17.29-7.8,17.68-12.48",
    transform: "translate(-33.88 -43.6)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M166.41,187.23s-1.26,11.78-7.16,12-18-5.81-18.86-13.27",
    transform: "translate(-33.88 -43.6)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M127.37,197.67s4.15,18.83,13,18.57,13-18.16,13-18.16",
    transform: "translate(-33.88 -43.6)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M95,119.16s9.58-8.43,17-7.53",
    transform: "translate(-33.88 -43.6)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M178.62,117.7s-9.57-8.43-17-7.53",
    transform: "translate(-33.88 -43.6)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M131.73,123.29s.47,4.25-2.87,10.81",
    transform: "translate(-33.88 -43.6)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M146.51,123.29s-.47,4.25,2.87,10.81",
    transform: "translate(-33.88 -43.6)"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 105.23,
    y1: 79.14,
    x2: 105.23,
    y2: 91.07
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M207.37,244.52c9,.27,20.08-8.42,26-13.73a11.48,11.48,0,0,0,3.53-10.8c-2-10-7.79-23.47-7.79-23.47,43.66,17.11-37.7-85.91-37.7-85.91,12.17.25,25.19-11,31-23.49s5.7-42.26-12.94-41S194.73,69.63,191.79,85.2s-13.66,16.09-13.66,16.09-38.15-13.92-77.93,0c0,0-10.73-.51-13.66-16.09s1-37.78-17.62-39.06S50.2,74.61,56,87.12s18.81,23.74,31,23.49c0,0-81.36,103-37.7,85.91,0,0-5.78,13.5-7.79,23.47A11.48,11.48,0,0,0,45,230.79c5.88,5.31,16.91,14,26,13.73",
    transform: "translate(-33.88 -43.6)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.86,218",
    transform: "translate(-33.88 -43.6)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsweria);
export default __webpack_public_path__ + "static/media/iconsweria.f9952a83bb275798fdd3843efb633064.svg";
export { ForwardRef as ReactComponent };